import React from "react";
import BroadcastViewers from "./broadcast-viewers";
import TailwindFlex from "library/components/_tailwind/flex";
import TailwindBox from "library/components/_tailwind/box";
import TailwindCard from "library/components/_tailwind/card";
import ChatStore from "./_stores/chat/ChatStore";
import BroadcastStore from "./_stores/broadcast/BroadcastStore";
import PrivateRequestCard from "./broadcast-preview/broadcast-private-request";
import { inject, observer } from "mobx-react";
import ViewersSortSelect from "./broadcast-tabs-viewers-sort-select";
import LayoutStore from "library/core/stores/layout/LayoutStore";

type ViewerTabProps = {
  chatStore?: ChatStore;
  broadcastStore?: BroadcastStore;
  layoutStore?: LayoutStore;
  onWhisperClick?: () => void;
};

const BroadcastViewersTab: React.ComponentType<ViewerTabProps> = ({
  broadcastStore,
  layoutStore,
  onWhisperClick,
}) => {
  const { isPrivateConsentOpen } = broadcastStore!;
  const { screenOrientation } = layoutStore!;
  const isIpadLandscape =
    Boolean(LayoutStore.isAppleTablet()) &&
    screenOrientation === "landscape";

  return (
    <TailwindBox
      width={"w-full"}
      height={isIpadLandscape ? "h-full" : undefined}
      flex={"flex-1"}
      display='flex'
      minHeight={isIpadLandscape ? "min-h-0" : undefined}
      overflow={
        isIpadLandscape
          ? isPrivateConsentOpen
            ? "overflow-y-auto"
            : "overflow-hidden"
          : undefined
      }
      className={
        !isIpadLandscape && isPrivateConsentOpen ? ["overflow-y-auto"] : []
      }
      flexDirection='flex-col'>
      {isPrivateConsentOpen && <PrivateRequestCard />}
      <TailwindFlex
        width={"w-full"}
        backgroundColor={"bg-primary-bg-color"}
        margin={isIpadLandscape ? undefined : ["mb-3"]}
        height={isIpadLandscape ? "h-full" : "h-screen"}
        flexGrow={"flex-grow"}
        minHeight='min-h-0'
        overflow={isIpadLandscape ? "overflow-hidden" : undefined}>
        <TailwindCard
          width='w-full'
          display='flex'
          flexDirection='flex-col'
          height='h-full'
          minHeight={isIpadLandscape ? "min-h-0" : undefined}
          overflow={isIpadLandscape ? "overflow-hidden" : undefined}
          padding={["p-3", "pt-1"]}>
          <ViewersSortSelect />
          <BroadcastViewers onWhisperClick={onWhisperClick} />
        </TailwindCard>
      </TailwindFlex>
    </TailwindBox>
  );
};

export default inject(
  "broadcastStore",
  "layoutStore"
)(observer(BroadcastViewersTab));
